import React from 'react'
import './Footer.css'
import ReliefLogo from '../ReliefLogo.png'

export default function Footer() {
  return (

         <div className="footer">
        <div className="foot">
          <img height="100px" src={ReliefLogo} alt="" />
          <h3>About Us</h3>
          <p>One stop solution for getting rid off mental stress</p> <br />
          <h4>Contact Us</h4>
          <p>859834755</p>
          <p>contact.technomaits@gmail.com</p>
        </div>
        <div className="foot">
          <h3>Information </h3> 
          <p>About Us</p>
          <p>More Search</p>
          <p>blogs</p>
          <p>events</p>
        </div>
        <div className="foot">
          <h3>Helpful Links</h3>
          <p>services</p>
          <p>supports</p>
          <p>terms &amp; conditions</p>
          <p>privacy policy</p>
        </div>
      </div>
    
  )
}
